import { render } from "./LoaderHtml.vue?vue&type=template&id=277a4871&scoped=true"
import script from "./LoaderHtml.vue?vue&type=script&lang=js"
export * from "./LoaderHtml.vue?vue&type=script&lang=js"

import "./LoaderHtml.vue?vue&type=style&index=0&id=277a4871&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277a4871"]])

export default __exports__